import { render, staticRenderFns } from "./GridHistory.vue?vue&type=template&id=36158abf"
import script from "./GridHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridHistory.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports